import createPersistedState from 'use-persisted-state'
import { Session } from './types'
import { SESSION_STORAGE_KEY } from '../storage'

/**
 * The full signed-in session (identity + roles + quota), shared with every pilet.
 *
 * The sibling of {@link useUser}: same `use-persisted-state` mechanism (a store in
 * module scope, shared through the shell's importmap so a write reaches every pilet
 * in the tab without a reload), keyed `'session'`. {@link AuthProvider} is the single
 * writer — it fills this from `whoami` alongside `'user'`. `'user'` stays the identity
 * that favorites/watch-later/the profile form read; a pilet that needs roles or quota
 * reads this instead of re-fetching whoami.
 */
const useSessionState = createPersistedState(SESSION_STORAGE_KEY)

export const useSession = () => useSessionState<Session | null>(null)
